module.exports = __webpack_public_path__ + "img/img-22.1986eb0e.svg";